export default __webpack_public_path__ + "static/media/f4.7be1235c.svg";